import dayjs from 'dayjs'
import { permsJudge } from '@/utils/auth'

// 自定义全局指令
export default {
  install(app) {
    // 用于格式化日期，只适用于直接放在元素下的内容，不传入格式的话默认格式为YYYY-MM-DD HH:mm:ss
    app.directive('formatDate', {
      mounted: (el, binding) => {
        const { value = 'DD/MM/YYYY HH:mm:ss' } = binding
        const text = el.innerText
        if (!text) return
        try {
          const formatText = dayjs(text).format(value)
          el.innerText = formatText
        } catch (error) {}
      }
    })

    // 手机号脱敏
    app.directive('phone', {
      mounted: (el, binding) => {
        const text = el.innerText
        if (text === undefined || text === null) return
        const regex = /^1[3456789]\d{9}$/
        if (!regex.test(text)) return
        el.innerText = text.replace(/^(\d{3})\d*(\d{4})$/, function (_, prefix, suffix) {
          return `${prefix}****${suffix}`
        })
      }
    })

    // 数字输入框控制输入格式
    // binding.value 属性包括：
    // negative = false是否可为负数，默认不可；precision = 2 小数精度，默认2位，如果为0表示不能输入小数； min 最小值, max 最大值
    app.directive('limitNumber', {
      mounted(el, binding) {
        // 用于保存该次输入之前的数据，如果校验未通过，恢复上次的值内容
        let prevValue
        // 在数字输入框只能允许点击 数字0-9、减号、小数点、删除键、上下左右键
        const allowKeys = [
          '0',
          '1',
          '2',
          '3',
          '4',
          '5',
          '6',
          '7',
          '8',
          '9',
          '-',
          '.',
          'backspace',
          'delete',
          'arrowup',
          'arrowdown',
          'arrowleft',
          'arrowright'
        ]
        el.onkeydown = (e) => {
          if (!allowKeys.includes(e.key.toLowerCase())) {
            e.preventDefault()
            return
          }
          const ipt = el.querySelector('input')
          prevValue = ipt.value
        }
        el.oninput = () => {
          const { negative = false, precision = 2, min, max } = binding.value || {}
          const iptValue = el.querySelector('input').value
          if (iptValue === '') return
          // 不能为负数但输入负号
          if (!negative && iptValue.indexOf('-') > -1) {
            el.querySelector('input').value = prevValue
            return
          }
          // 不能为小数但输入了小数点
          if (precision === 0 && iptValue.indexOf('.') > -1) {
            el.querySelector('input').value = prevValue
            return
          }
          // 有最小值 但比最小值还小，包含也不行
          if (min !== undefined && iptValue <= min) {
            el.querySelector('input').value = prevValue
            return
          }
          // 有最大值 但比最大值还大
          if (max !== undefined && iptValue > max) {
            el.querySelector('input').value = prevValue
            return
          }
          // 不为数字，多输入了负号或小数点
          if (isNaN(iptValue)) {
            el.querySelector('input').value = prevValue
            return
          }
          if (precision > 0) {
            const v = `^-?\\d+(\\.\\d{0,${precision}})?$`
            const reg = new RegExp(v, 'g')
            const valid = reg.test(iptValue)
            if (!valid) {
              el.querySelector('input').value = prevValue
            }
          }
        }
      }
    })

    // 权限控制
    app.directive('hasPermission', {
      mounted(el, binding) {
        // console.log('binding', binding.value);

        if (!permsJudge(binding.value)) {
          el.parentNode.removeChild(el)
        }
      }
    })
  }
}
